export const API_URL = "https://verify.dexcart.in/api/";